export { BaseCard } from './BaseCard'
export type { BaseCardProps } from './BaseCard'

